import { useMessageChannels } from 'modules/workflowNodeEditors/components/StartNodeEditor/StartNodeEditor.hooks';
import { FilterListValueInput } from '../FilterListInput/FilterListValueInput';

type FilterListMembershipValueInputProps = {
  onChange: (value: string) => void;
  value: string;
  id: string;
  isDisabled?: boolean;
  hasError: boolean;
  placeholder?: string;
};

export const FilterMessageChannelInput = ({
  id,
  onChange,
  value,
  isDisabled = false,
  hasError,
  placeholder,
}: FilterListMembershipValueInputProps) => {
  const { messageChannels, isLoading } = useMessageChannels();
  const listType = 'channel';
  return (
    <FilterListValueInput
      id={id}
      lists={messageChannels}
      placeholder={placeholder}
      listType={listType}
      isDisabled={isDisabled || isLoading}
      onChange={onChange}
      value={value}
      isLoading={isLoading}
      hasError={hasError}
    />
  );
};
